import { message } from 'antd'
import COS from 'cos-js-sdk-v5'
import { getCOS } from '../api/api'
import compressImg from './compress'

const uuid = require('uuid')
const getOriginUuid = uuid.v1()
const getThumbnailUuid = uuid.v1()

const Bucket = 'warwickwexon-1314590141'
const Region = 'ap-shanghai'
const COSinstance = () => {
  const cos = new COS({
    UseAccelerate: true, // 指定 true，使用全球加速域名请求
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
      // 异步获取临时密钥
      // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
      // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
      // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
      getCOS().then((res) => {
        const data = res.data.data.CredentialResult
        const credentials = data.Credentials
        // prefix = res.data.data.Prefix
        // localStorage.setItem('prefix',prefix)
        callback({
          TmpSecretId: credentials.TmpSecretId,
          TmpSecretKey: credentials.TmpSecretKey,
          SecurityToken: credentials.Token,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: data.StartTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: data.ExpiredTime, // 时间戳，单位秒，如：1580000000
        })
      })
    },
  })
  return cos
}

const handleFileInCompressUploading = (file, afterUpload) => {
  const cos = COSinstance()
  // console.log(file)
  // console.log(localStorage.getItem('prefix'))
  getCOS()
    .then((res) => {
      const prefix = res.data.data.Prefix
      // localStorage.setItem('prefix', prefix)
      return new Promise((resolve, rej) => {
        resolve(prefix)
      })
    })
    .then(async (prefix) => {
      const compressFile = await compressImg(file, 0.2)
      cos.putObject(
        {
          Bucket: Bucket /* 填写自己的 bucket，必须字段 */,
          Region: Region /* 存储桶所在地域，必须字段 */,
          Key:
            prefix +
            '-' +
            getOriginUuid +
            '-' +
            'origin-' +
            file.name /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: compressFile.origin, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            // console.log(JSON.stringify(progressData))
          },
        },
        function (err, data1) {
          if (err) {
            console.log('上传失败', err)
            message('上传失败!', err)
          } else {
            // console.log('origin', data1)
            const originUrl = data1.Location
            cos.putObject(
              {
                Bucket: Bucket /* 填写自己的 bucket，必须字段 */,
                Region: Region /* 存储桶所在地域，必须字段 */,
                Key:
                  prefix +
                  '-' +
                  getThumbnailUuid +
                  '-' +
                  'thumbnail-' +
                  file.name /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
                Body: compressFile.file, // 上传文件对象
                SliceSize:
                  1024 *
                  1024 *
                  5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
                onProgress: function (progressData) {
                  // console.log(JSON.stringify(progressData))
                },
              },
              function (err, data2) {
                if (err) {
                  console.log('上传失败', err)
                  message('上传失败!', err)
                } else {
                  // console.log('thumbnail', data2)
                  const thumbnail = data2.Location
                  console.log("上传成功！")
                  // console.log('thumbnail', thumbnail)
                  // console.log('originUrl', originUrl)
                  afterUpload(originUrl, thumbnail, file)
                }
              }
            )
          }
        }
      )
    })
}

export default handleFileInCompressUploading
